import React from "react";
import CardMC from '../../../components/CardMC';
import CheckBoxMC from '../../../components/CheckBoxMC';

const PaymentMethod = ({ method, handleSelected }) => (
  <div onClick={() => handleSelected(method)} className="tw-cursor-pointer">
    <CardMC className="tw-p-2 tw-gap-4 tw-justify-between">
      <div className="tw-flex tw-gap-1">
        <img src={method.icon} className="tw-flex-shrink-0 tw-w-[26px] tw-h-[26px] tw-rounded-[5px]" />
        <span className="tw-text-sm tw-text-gray-950">{method.name}</span>
      </div>
      <div className="tw-flex tw-items-center tw-justify-center">
        <CheckBoxMC
          checked={method.selected}
          onChange={() => { }}
          className="tw-w-5 tw-h-5"
        />
      </div>
    </CardMC>
  </div>
);

export default PaymentMethod;
